export var ComponentSizes;
(function (ComponentSizes) {
    ComponentSizes["XLarge"] = "x-large";
    ComponentSizes["Large"] = "large";
    ComponentSizes["Medium"] = "medium";
    ComponentSizes["Small"] = "small";
    ComponentSizes["XSmall"] = "x-small";
    ComponentSizes["SuperSmall"] = "super-small";
})(ComponentSizes || (ComponentSizes = {}));
export var PersonDemographicTypes;
(function (PersonDemographicTypes) {
    PersonDemographicTypes["Provider"] = "provider";
    PersonDemographicTypes["DirectToConsumer"] = "DTC";
    PersonDemographicTypes["Chatbot"] = "CHATBOT";
})(PersonDemographicTypes || (PersonDemographicTypes = {}));
export var TextQuestionType;
(function (TextQuestionType) {
    TextQuestionType["Text"] = "text";
    TextQuestionType["Tel"] = "tel";
    TextQuestionType["Email"] = "email";
    TextQuestionType["Date"] = "date";
    TextQuestionType["Number"] = "number";
    TextQuestionType["Age"] = "age";
    TextQuestionType["Dob"] = "dob";
    TextQuestionType["Name"] = "name";
    TextQuestionType["Address"] = "address";
    TextQuestionType["Postal"] = "postal";
    TextQuestionType["Image"] = "image";
    TextQuestionType["Mrn"] = "mrn";
})(TextQuestionType || (TextQuestionType = {}));
export var UploadImageType;
(function (UploadImageType) {
    UploadImageType["JPEG"] = "image/jpeg";
    UploadImageType["PNG"] = "image/png";
    UploadImageType["JPG"] = "image/jpg";
    UploadImageType["GIF"] = "image/gif";
})(UploadImageType || (UploadImageType = {}));
export var FieldOptionType;
(function (FieldOptionType) {
    FieldOptionType["REQUIRED"] = "REQUIRED";
    FieldOptionType["DISPLAYED"] = "DISPLAYED";
    FieldOptionType["HIDDEN"] = "HIDDEN";
})(FieldOptionType || (FieldOptionType = {}));
export var PolicyHolderRelationsType;
(function (PolicyHolderRelationsType) {
    PolicyHolderRelationsType[PolicyHolderRelationsType["self"] = 1] = "self";
    PolicyHolderRelationsType[PolicyHolderRelationsType["spouse"] = 2] = "spouse";
    PolicyHolderRelationsType[PolicyHolderRelationsType["child"] = 3] = "child";
    PolicyHolderRelationsType[PolicyHolderRelationsType["other"] = 4] = "other";
})(PolicyHolderRelationsType || (PolicyHolderRelationsType = {}));
export var PersonInsuranceFormFieldsType;
(function (PersonInsuranceFormFieldsType) {
    PersonInsuranceFormFieldsType["PolicyHolderLastName"] = "policyHolderLastName";
    PersonInsuranceFormFieldsType["PolicyHolderFirstName"] = "policyHolderFirstName";
    PersonInsuranceFormFieldsType["PolicyHolderDob"] = "policyHolderDob";
    PersonInsuranceFormFieldsType["PolicyHolderRelation"] = "policyHolderRelation";
    PersonInsuranceFormFieldsType["InsuranceId"] = "insuranceId";
    PersonInsuranceFormFieldsType["InsuranceProvider"] = "insuranceProvider";
    PersonInsuranceFormFieldsType["InsuranceCardImageFront"] = "insuranceCardImageFront";
    PersonInsuranceFormFieldsType["InsuranceCardImageBack"] = "insuranceCardImageBack";
    PersonInsuranceFormFieldsType["isUninsured"] = "isUninsured";
})(PersonInsuranceFormFieldsType || (PersonInsuranceFormFieldsType = {}));
